import React from 'react';
import { useInView } from 'react-intersection-observer';
import { useTranslation } from 'react-i18next';
import './About1.css';
import image1 from '../../Assets/about1.png';
import image2 from '../../Assets/about2.png';
import image3 from '../../Assets/about3.jpg';
import image4 from '../../Assets/about4.jpg';

const About1 = () => {
    const { t } = useTranslation('about');
    
    const items = [
      {
      text: t('result1'),
      image: image1
      },
      {
      text: t('result2'),
      image: image2
      },
      {
      text: t('result3'),
      image: image3
      },
      {
      text: t('result4'),
      image: image4
      }
    ];

    return (
        <div>
            <div className="aboutContainer">
            <div className='HomeComponent'>
                <div className="titleContainer">
                    <h1 className="title">{t('title')}</h1>
                </div>
            </div>
            <p className="projectDescription">{t('description')}</p>
            <div className="resultsList">
                {items.map((item, index) => {
                    const [ref, inView] = useInView({
                        threshold: 0,
                        triggerOnce: true,
                    });

                    const isEven = index % 2 === 0;

                    return (
                        <div key={index} ref={ref} className={`fade-in-section ${inView ? 'is-visible' : ''} ${isEven ? 'even' : 'odd'}`}>
                            {isEven ? (
                                <>
                                           <div className="image1"><img src={item.image} alt={`about${index + 1}`} /></div>
                                    <div className="text1">{item.text}</div>
                                </>
                            ) : (
                                <>
                                    <div className="image2"><img src={item.image} alt={`about${index + 1}`} /></div>
                                    <div className="text2">{item.text}</div>
                                </>
                            )}
                        </div>
                    );
                })}
            <hr style={{ 
    width: '95%', 
    height: '5px', 
    backgroundColor: 'black', 
    margin: '0 auto', // Adjusted margin for centering
    borderRadius: '5px',
    opacity: '30%',
}} />
            </div>
        </div>
        </div>
    );
};

export default About1;
